import { useEffect, useRef, useState } from "react";
import Modal from "../Modal";
import { getAllReleaseNotes } from "../../api/releaseNoteApi";
import { GrDocument } from "react-icons/gr";
import Button from "../../components/input/Button";
import { ChevronLeft } from "react-feather";

const ReleaseNotePopup = ({ onClose }) => {
  const PAGE_SIZE = 5;

  const modalRef = useRef();
  const [list, setList] = useState([]);
  const [selected, setSelected] = useState(null);
  const [page, setPage] = useState(0);

  useEffect(() => {
    modalRef.current?.showModal();

    (async () => {
      const res = await getAllReleaseNotes();
      const data = res || [];

      const sorted = data.sort(
        (a, b) => new Date(b.releaseDate) - new Date(a.releaseDate)
      );

      setList(sorted);
    })();
  }, []);

  const handleClose = () => {
    modalRef.current?.close();
    onClose();
  };

  const handleNext = () => {
    setPage((prev) => prev + 1);
  };

  const handlePrevious = () => {
    setPage((prev) => Math.max(0, prev - 1));
  };

  return (
    <Modal
      ref={modalRef}
      minWidth="700px"
      onCloseCleanUp={handleClose}
      closeButton={false}
    >
      <div
        style={{
          padding: "12px",
          background: "#fff",
          borderRadius: "16px",
        }}
      >

        {!selected && (
          <div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "15px",
                borderBottom: "1px solid #eee",
                paddingBottom: "10px",
              }}
            >
              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  color: "#2c3e50",
                }}
              >
                Latest Release Notes
              </div>

              <Button
                label="Close"
                onClick={handleClose}
                style={{
                  backgroundColor: "#3498db",
                  color: "#fff",
                }}
              />
              </div>

            <div style={{ display: "grid", gap: "12px" }}>
              {list.slice(page * PAGE_SIZE, page * PAGE_SIZE + PAGE_SIZE).map((item) => (
                <div
                  key={item.id}
                  onClick={() => setSelected(item)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "16px",
                    border: "1px solid #d6e4f0",
                    borderRadius: "12px",
                    background: "#f9fbfd",
                    cursor: "pointer",
                    transition: "0.2s",
                  }}
                >
                  <div
                    style={{
                      width: "60px",
                      height: "60px",
                      background: "#eef3f7",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "16px",
                    }}
                  >
                    <GrDocument size={26} color="#3498db" />
                  </div>

                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        fontSize: "18px",
                        fontWeight: "700",
                        color: "#1f2d3d",
                        marginBottom: "6px",
                      }}
                    >
                      {item.title}
                    </div>

                    <div
                      style={{
                        fontSize: "14px",
                        color: "#6c7a89",
                        marginBottom: "6px",
                      }}
                    >
                      {item.version} | Release Note
                    </div>

                    <div
                      style={{
                        fontSize: "12px",
                        color: "#999",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>{item.releaseDate}</span>
                      <span>Release</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {list.length > PAGE_SIZE && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                  marginTop: "16px",
                }}
              >
                <Button
                  label="Previous"
                  onClick={handlePrevious}
                  disabled={page === 0}
                  style={{
                    backgroundColor: "#3498db",
                    color: "#fff",
                  }}
                />
                <Button
                  label="Next"
                  onClick={handleNext}
                  disabled={page * PAGE_SIZE + PAGE_SIZE >= list.length}
                  style={{
                    backgroundColor: "#3498db",
                    color: "#fff",
                  }}
                />
              </div>
            )}
          </div>
        )}

        {selected && (
  <div
    style={{
      display: "flex",
      gap: "16px",
      padding: "20px",
      border: "1px solid #d6e4f0",
      borderRadius: "12px",
      background: "#f9fbfd",
      height: "400px",
      overflow: "hidden",
    }}
  >
    <div
      style={{
        width: "70px",
        height: "70px",
        background: "#eef3f7",
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      <GrDocument size={28} color="#3498db" />
    </div>

    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <div
          style={{
            fontSize: "20px",
            fontWeight: "700",
            color: "#1f2d3d",
          }}
        >
          {selected.title}
        </div>

        <Button
          template="back"
          onClick={() => setSelected(null)}
        />
      </div>

      <div style={{ fontSize: "14px", color: "#6c7a89" }}>
        {selected.version} | Release Note
      </div>
    
      <div
        style={{
          fontSize: "12px",
          color: "#999",
          marginBottom: "10px",
        }}
      >
        Released Date: {selected.releaseDate}
      </div>

      <div
        style={{
          flex: 1,
          overflowY: "auto",
          paddingRight: "6px",
        }}
        dangerouslySetInnerHTML={{
          __html: selected.description,
        }}
      />
    </div>
  </div>
)}
      </div>
    </Modal>
  );
};

export default ReleaseNotePopup;